// Shared formatting helpers used across player components and HUD widgets.

export const parseDecimal = (n) => {
  return Math.round(n * 100) / 100
}
